import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import Layout from '../components/Layout';

export default function Statistiche() {
  const [dati, setDati] = useState(null);
  const [errore, setErrore] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/statistiche')
      .then(r => setDati(r.data))
      .catch(() => setErrore('Errore nel caricamento delle statistiche'));
  }, []);

  if (errore) return <Layout><div style={styles.errore}>{errore}</div></Layout>;
  if (!dati) return <Layout><p>Caricamento...</p></Layout>;

  const formatData = (d) => d ? new Date(d).toLocaleDateString('it-IT') : 'Mai';
  const mesiNomi = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];

  return (
    <Layout>
      <h2 style={{ marginTop: 0 }}>Pannello di Controllo Studio</h2>

      {/* Contatori principali */}
      <div style={styles.contatori}>
        <div style={styles.contatore}>
          <div style={styles.contatoreValore}>{dati.totali.totale_clienti}</div>
          <div style={styles.contatoreLabel}>Clienti Attivi</div>
        </div>
        <div style={styles.contatore}>
          <div style={styles.contatoreValore}>{dati.totali.totale_lavoratori}</div>
          <div style={styles.contatoreLabel}>Lavoratori</div>
        </div>
        <div style={{ ...styles.contatore, borderLeft: '4px solid #2e7d32' }}>
          <div style={styles.contatoreValore}>{dati.totali.comunicazioni_inviate}</div>
          <div style={styles.contatoreLabel}>Comunicazioni Inviate</div>
        </div>
        <div style={{ ...styles.contatore, borderLeft: '4px solid #c00' }}>
          <div style={styles.contatoreValore}>{dati.totali.comunicazioni_annullate}</div>
          <div style={styles.contatoreLabel}>Annullate</div>
        </div>
        <div style={{ ...styles.contatore, borderLeft: '4px solid #e65100' }}>
          <div style={styles.contatoreValore}>{dati.totali.comunicazioni_errore}</div>
          <div style={styles.contatoreLabel}>Errori</div>
        </div>
      </div>

      {/* Alert clienti inattivi */}
      {dati.clienti_inattivi.length > 0 && (
        <div style={styles.sezioneAlert}>
          <h3 style={{ margin: '0 0 1rem', color: '#c00' }}>
            Clienti senza comunicazioni da oltre {dati.giorni_alert} giorni
          </h3>
          <div style={styles.alertGrid}>
            {dati.clienti_inattivi.map(c => (
              <div key={c.id} style={styles.alertCard}>
                <strong>{c.ragione_sociale}</strong>
                <span style={{ color: '#999', fontSize: '0.85rem' }}>
                  Ultima: {formatData(c.ultima_comunicazione)}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={styles.gridDue}>
        {/* Comunicazioni per mese */}
        <div style={styles.sezione}>
          <h3 style={{ margin: '0 0 1rem' }}>Comunicazioni per Mese</h3>
          {dati.per_mese.length > 0 ? (
            <div style={styles.grafico}>
              {dati.per_mese.map(m => {
                const max = Math.max(...dati.per_mese.map(x => parseInt(x.totale)));
                const pct = max > 0 ? (parseInt(m.totale) / max) * 100 : 0;
                const [anno, mese] = m.mese.split('-');
                return (
                  <div key={m.mese} style={styles.barraRow}>
                    <span style={styles.barraLabel}>{mesiNomi[parseInt(mese) - 1]} {anno.slice(2)}</span>
                    <div style={styles.barraContainer}>
                      <div style={{ ...styles.barra, width: `${pct}%` }}>{m.totale}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p style={{ color: '#999' }}>Nessun dato disponibile</p>
          )}
        </div>

        {/* Top lavoratori mese corrente */}
        <div style={styles.sezione}>
          <h3 style={{ margin: '0 0 1rem' }}>Top Lavoratori (mese corrente)</h3>
          {dati.top_lavoratori.length > 0 ? (
            <table style={styles.tableMini}>
              <thead>
                <tr>
                  <th style={styles.thMini}>Lavoratore</th>
                  <th style={styles.thMini}>Azienda</th>
                  <th style={styles.thMini}>Com.</th>
                </tr>
              </thead>
              <tbody>
                {dati.top_lavoratori.map((l, i) => (
                  <tr key={i} style={styles.trMini}>
                    <td style={styles.tdMini}>{l.cognome} {l.nome}</td>
                    <td style={styles.tdMini}>{l.ragione_sociale}</td>
                    <td style={{ ...styles.tdMini, fontWeight: 'bold' }}>{l.totale}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: '#999' }}>Nessuna comunicazione questo mese</p>
          )}
        </div>
      </div>

      {/* Riepilogo per cliente */}
      <div style={styles.sezione}>
        <h3 style={{ margin: '0 0 1rem' }}>Riepilogo per Cliente</h3>
        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Azienda</th>
                <th style={styles.th}>Inviate</th>
                <th style={styles.th}>Annullate</th>
                <th style={styles.th}>Totale</th>
                <th style={styles.th}>Ultima Comunicazione</th>
                <th style={styles.th}>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {dati.per_cliente.map(c => (
                <tr key={c.id} style={styles.tr}>
                  <td style={styles.td}><strong>{c.ragione_sociale}</strong></td>
                  <td style={styles.td}>{c.inviate}</td>
                  <td style={styles.td}>{c.annullate}</td>
                  <td style={styles.td}>{c.totale_comunicazioni}</td>
                  <td style={styles.td}>{formatData(c.ultima_comunicazione)}</td>
                  <td style={styles.td}>
                    <button onClick={() => navigate(`/comunicazioni?azienda_id=${c.id}`)} style={styles.btnSmall}>Vedi</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}

const styles = {
  contatori: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1rem', marginBottom: '1.5rem' },
  contatore: { background: 'white', padding: '1.2rem', borderRadius: '10px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', borderLeft: '4px solid #232323' },
  contatoreValore: { fontSize: '2rem', fontWeight: 'bold', color: '#232323' },
  contatoreLabel: { fontSize: '0.85rem', color: '#666', marginTop: '0.3rem' },
  sezioneAlert: { background: '#fff5f5', padding: '1.5rem', borderRadius: '10px', border: '1px solid #fcc', marginBottom: '1.5rem' },
  alertGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '0.5rem' },
  alertCard: { background: 'white', padding: '0.8rem', borderRadius: '6px', display: 'flex', flexDirection: 'column', gap: '0.3rem', border: '1px solid #fdd' },
  gridDue: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginBottom: '1.5rem' },
  sezione: { background: 'white', padding: '1.5rem', borderRadius: '10px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: '1.5rem' },
  grafico: { display: 'flex', flexDirection: 'column', gap: '0.4rem' },
  barraRow: { display: 'flex', alignItems: 'center', gap: '0.5rem' },
  barraLabel: { width: '55px', fontSize: '0.8rem', color: '#666', textAlign: 'right' },
  barraContainer: { flex: 1, background: '#f0f2f5', borderRadius: '4px', height: '24px' },
  barra: { background: '#232323', height: '100%', borderRadius: '4px', color: 'white', fontSize: '0.75rem', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '25px' },
  tableMini: { width: '100%', borderCollapse: 'collapse' },
  thMini: { textAlign: 'left', padding: '0.5rem', borderBottom: '2px solid #eee', fontSize: '0.8rem', color: '#555' },
  trMini: { borderBottom: '1px solid #f5f5f5' },
  tdMini: { padding: '0.5rem', fontSize: '0.85rem' },
  tableWrapper: { overflowX: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { textAlign: 'left', padding: '0.8rem', background: '#f8f9fa', borderBottom: '2px solid #eee', fontSize: '0.85rem', color: '#555' },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '0.7rem 0.8rem', fontSize: '0.9rem' },
  btnSmall: { background: '#eef', color: '#232323', border: 'none', padding: '0.3rem 0.7rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8rem' },
  errore: { background: '#fee', color: '#c00', padding: '1rem', borderRadius: '6px' },
};
